import axios from 'axios';

import AjaxService from '../services/ajax-service';

export const searchUsers = ({ type, searchTerm, excludedUsers = [] }) => {
    return AjaxService({
        method: 'get',
        url: `search/${type}`,
        params: {
            query: searchTerm
        }
    }).then(response => response.data.items.filter(user => !excludedUsers.includes(user.id)));
}

export const searchUsersForAssociation = ({ type, association, id, searchTerm, excludedUsers = []}) => {
    return AjaxService({
        method: 'get',
        url: 'search/users',
        params: {
            type,
            association,
            id,
            query: searchTerm || undefined
        }
    }).then(response => response.data.items.filter(user => !excludedUsers.includes(user.id)));
}

let lastSearchCancel = null;
export const search = ({ term, type, teamchat, projectId, offset, limit }: any) => {
    lastSearchCancel && lastSearchCancel();

    return AjaxService({
        method: 'get',
        url: 'api/search',
        params: {
            query: term,
            type,
            offset,
            limit,
            project_ids: projectId && JSON.stringify([projectId])
        },
        cancelToken: new axios.CancelToken(cancel => {
            lastSearchCancel = cancel;
        })
    }).then(response => response.data);
};
